import React from 'react';

import cx from 'classnames';

import { ReactComponent as EditIcon } from 'pages/Teachers/ClassroomInsights/assets/edit-icon.svg';
// import { ReactComponent as PublishIconGray } from 'pages/Teachers/ClassroomInsights/assets/publish-icon-gray.svg';
import { ReactComponent as SelectAllIcon } from 'pages/Teachers/ClassroomInsights/assets/select-all.svg';

import styles from './style.module.scss';

const BulkActions = ({
  hasFilters,
  hasSelectedStudents,
  allStudentsSelected,
  onEditClick,
  onSelectAll,
  onPublishClick
}) => {
  return (
    <div
      className={cx(styles.actionsContainer, {
        [styles.hasFilters]: hasFilters
      })}
    >
      <div className={styles.actionLayout} onClick={onSelectAll}>
        <SelectAllIcon />
        <span className={styles.actionText}>
          {allStudentsSelected ? 'Unselect All' : 'Select All'}
        </span>
      </div>

      {hasSelectedStudents && (
        <>
          <div className={styles.actionLayout} onClick={onEditClick}>
            <EditIcon />
            <span className={styles.actionText}>Edit</span>
          </div>

          {/* <div className={styles.actionLayout} onClick={onPublishClick}>
              <PublishIconGray />
              <span className={styles.actionText}>Publish</span>
            </div> */}
        </>
      )}
    </div>
  );
};

export default BulkActions;
